import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { useCipEvents, useErrorHandler } from 'src/services';
import { useResourceActions } from 'src/store/resource';

import { ResourcePopup } from './ResourcePopup';

export const RESOURCE_POPUP = Symbol('RESOURCE');

export const useResourcePopup = () => {
  const popups = usePopups();
  const resourceActions = useResourceActions();
  const cipEvents = useCipEvents();
  const handleError = useErrorHandler();

  useEffectOnce(() => {
    popups.registerPopup(RESOURCE_POPUP, ResourcePopup);
  });

  return useCallback(
    ({ resource, forceDocumentOnly } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(RESOURCE_POPUP, {
          resource,
          forceDocumentOnly,

          onClose: () => {
            popups.closePopup(RESOURCE_POPUP);
            resolve();
          },

          onSubmit: async (result) => {
            try {
              cipEvents.trackAddResource();
              resolve({
                ...result,
              });
              resourceActions.queryWorkspaceResources().catch(handleError);
              popups.closePopup(RESOURCE_POPUP);
            } catch (error) {
              popups.closePopup(RESOURCE_POPUP);
              handleError(error);
              resolve();
            }
          },
        });
      });
    },
    [popups, cipEvents, handleError, resourceActions]
  );
};
